<main class="app-container">
    <app-universal-nav [cLang]="curLang" SideNavData="drawer" [RightNavData]="rightDraw.drawer" (childEvent)="handleChange($event)" (langEvent)="sendLanguage($event)">
    </app-universal-nav>
    <mat-drawer-container class="container-fluid p-0" autosize>
      <mat-drawer #drawer class="sidenav mat-elevation-z3" [mode]="modechk" opened position="start">
        <app-main-menu></app-main-menu>
      </mat-drawer>
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
      <app-right-panel #rightDraw [RightNavData]="rightDraw.drawer">
        <app-application *ngIf="(isApp) && (key=='app')"></app-application>
        <app-my-profile [RightNavData]="rightDraw.drawer" *ngIf="(isProfile) && (key=='profile')"></app-my-profile>
        <app-alert  [RightNavData]="rightDraw.drawer" *ngIf="(isAlert) && (key=='alert')"></app-alert>
        <app-search [RightNavData]="rightDraw.drawer" *ngIf="(isSearch) && (key=='search')"></app-search>
        <!-- <dhhp-language [languages]="addLangs" [RightNavData]="rightDraw.drawer" (languageEvent)="getLanguage($event)" *ngIf="(isLang) && (key=='language')"></dhhp-language> -->
        <app-help *ngIf="(isHelp) && (key=='help')"></app-help>
      </app-right-panel>
    </mat-drawer-container>
  </main>